import { render } from "./TarotDetailTitleArea.vue?vue&type=template&id=fb233ca6&scoped=true"
import script from "./TarotDetailTitleArea.vue?vue&type=script&lang=js"
export * from "./TarotDetailTitleArea.vue?vue&type=script&lang=js"

import "./TarotDetailTitleArea.vue?vue&type=style&index=0&id=fb233ca6&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fb233ca6"]])

export default __exports__